<template>
    <div class="products">
        <loader v-if="!hasLoaded"></loader>

        <template v-else>
            <multiselect placeholder="Add a new product" v-model="selected" track-by="label" label="label" :options="options" :close-on-select="true" :show-labels="false"></multiselect>

            <hr />

            <div class="list-group">
                <div class="list-group-item" v-for="product in chosenProducts" :key="product.id">
                    <input type="text" class="form-control pull-right quantity" v-model="product.quantity" />

                    {{product.title}}<br />

                    <small class="text-muted">
                        DKK {{product.price | fixedNumber(2) | moneyFormat}}
                    </small>
                </div>

                <div class="text-center" v-if="Object.keys(chosenProducts).length === 0">
                    No products
                </div>
            </div>

            <hr />

            <button class="btn btn-primary btn-block" @click="update">Save</button>
        </template>
    </div>
</template>

<style lang="scss">
    .products {
        position: relative;

        .quantity {
            max-width: 50px;
            margin-top: 5px;
        }
    }
</style>

<script>
    import Card from '@/components/layout/Card'
    import Loader from '@/components/layout/Loader'
    import Multiselect from 'vue-multiselect'

    const ReservationService = require('@/services/reservations/ReservationService')
    const ProductService = require('@/services/products/ProductService')

    export default {
        props: {
            id: String
        },

        data() {
            return {
                reservation: null,
                hasLoaded: false,
                products: [],
                selected: null,
                chosenProducts: {}
            }
        },

        watch: {
            selected() {
                if (!this.selected) {
                    return
                }

                const product = this.selected.value

                if (!this.chosenProducts[product.id]) {
                    this.$set(this.chosenProducts, product.id, {
                        title: product.name,
                        quantity: 0,
                        price: product.price
                    })
                }

                this.chosenProducts[product.id].quantity++

                setTimeout(() => {
                    this.selected = null
                }, 100)
            }
        },

        computed: {
            options() {
                return this.products.map((product) => {
                    return {
                        label: product.name,
                        value: product
                    }
                })
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                this.hasLoaded = false
                this.chosenProducts = {}

                ProductService.findAll({
                    sort: [{
                        key: 'name',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.products = data.rows

                    ReservationService.find(this.id, {}, (response) => {
                        this.reservation = response.data
                        this.hasLoaded = true

                        const products = this.reservation.products

                        if (products.length === 0) {
                            this.chosenProducts = {}

                            return
                        }

                        this.chosenProducts = products
                    })
                })
            },

            update() {
                let products = {}

                Object.keys(this.chosenProducts).forEach((id) => {
                    const product = this.chosenProducts[id]

                    if (product.quantity <= 0) {
                        return
                    }

                    products[id] = product
                })

                this.hasLoaded = false

                ReservationService.update(this.reservation.id, {products: products}, () => {
                    this.load()

                    eventHub.$emit('products.updated')
                })
            }
        },

        components: {
            Card,
            Loader,
            Multiselect
        }
    }
</script>


// WEBPACK FOOTER //
// Products.vue?5ce3ff88